import { render, staticRenderFns } from "./UploadEbook.vue?vue&type=template&id=5330c5c8&scoped=true"
import script from "./UploadEbook.vue?vue&type=script&lang=js"
export * from "./UploadEbook.vue?vue&type=script&lang=js"
import style0 from "./UploadEbook.vue?vue&type=style&index=0&id=5330c5c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330c5c8",
  null
  
)

export default component.exports